import { createStateSelectorHook } from 'src/lib/sweetState';

import { DISPLAY_MODE } from '../const';
import { MainStore } from '../store';

const useMainState = createStateSelectorHook(MainStore, ['currentDisplayMode']);

export const useIsDocumentModeActive = () => {
  const { currentDisplayMode } = useMainState();
  return currentDisplayMode === DISPLAY_MODE.document;
};
